/*
 * Exports
 */
export { default } from './components/DigitalCheckoutWorkflowView.component';



// WEBPACK FOOTER //
// ./app/components/shared/ItemTransactions/components/digital-checkout-workflow-view/index.js